export const replaceMediaSizeInUrl = (value, size = "large") => {
  if (!value) return value;
  return value.replace(/size=\w*/, `size=${size}`);
};
